{
    "title": "Johann Misterio",
    "description": "Web/Digital Strategy and Solutions",
    "permalink": "profile.j8nn3str.me",
    "randomstring":"oh8tfL@brkFgCCyiqm63iK4`;>iU>_rftVHfr@7PuwqY{25|G7",
    "docfilename": "Johann Misterio - Resume",
    "docauthor": "Johann Misterio",
    "contactform": "https://formspree.io/f/mgejgwlj"
  }
  